import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UpdateCaseConfirmationStateConfirmationData } from 'src/app/shared/interfaces/caseManagementCase';

@Component({
  selector: 'app-update-case-confirmation-state-confirmation-dialog',
  templateUrl:
    './update-case-confirmation-state-confirmation-dialog.component.html',
  styleUrls: [
    './update-case-confirmation-state-confirmation-dialog.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UpdateCaseConfirmationStateConfirmationDialogComponent {
  data = inject<UpdateCaseConfirmationStateConfirmationData>(MAT_DIALOG_DATA);

  constructor() {}
}
